import { onMounted, onBeforeUnmount } from 'vue'

import { useWebSiteStore } from '@/stores/web-site.store'

export const useKeydown = (callback) => {
  const webSiteStore = useWebSiteStore()
  onMounted(() => webSiteStore.addKeydownHandler(callback))
  onBeforeUnmount(() => webSiteStore.removeKeydownHandler(callback))
}

export const useEscapeClose = (isUpdated, onClose) => {
  useKeydown((event) => {
    if (event.key !== 'Escape') return
    if (isUpdated.value) {
      event.stopPropagation()
      return
    }
    onClose()
  })
}
